import styled from 'styled-components';
import {
  lightOrange,
  black,
  textLightGrey,
  darkGrey,
  lgGreen,
  white,
  textRed,
} from '../../constants/theme';
import { Dialog } from '@reach/dialog';

export const Button = styled.button`
    border: 1px solid ${lightOrange};
    background-color: ${white};
    white-space: nowrap;
    padding: 0;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    display inline-flex;
    line-height: 49px;
    position: relative;
    &:active,
      &:focus {
        box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
        outline: none;
      }
    }
    .text-box {
      font-size: 16px;
      width: 95%;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 15px;
      color: ${textLightGrey};
    }
    svg {
      position: absolute;
      float: right;
      top: 15px;
      right: 15px;
      font-size: 18px;
      color: ${lightOrange};
    }
 @media (min-width: 760px) and (max-width: 1024px) {
   .text-box {
     padding: 0 10px;
   }
   svg {
     right: 10px;
   }
 }
    
`;

export const SearchModal = styled.div`
  display: block;
  h4 {
    font-size: 26px;
    color: ${textRed};
    text-transform: capitalize;
    display: block;
    float: left;
  }
  img {
    width: 18px;
    height: 18px;
    float: right;
    margin-top: -10px;
    margin-right: -20px;
    margin-bottom: 20px;
  }
  h2 {
    text-transform: capitalize;
  }
  .has-children {
    button {
      color: ${black};
      font-weight: 600;
      font-size: 16px;
      padding: 0;
      text-align: left;
    }
    button:focus {
      outline: none;
    }
    
    &.active {
      button, button:focus {
         color: ${lgGreen};
      }
    }
  }
  .ok-btn {
    background-color: ${lgGreen} !important;
    color: ${white} !important;
  }
  button {
    background-color: transparent;
    border: none;
    font-size: 13px;
    color: ${darkGrey};
  }
  button:focus {
    background-color: transparent;
    outline: none;
    color: ${darkGrey};
  }
  modal-big {
    width: 100%;
  }
`;

export const StyledDialog = styled(Dialog)`
  width: 70% !important;
  height: auto !important;
  background-color: ${white} !important;
  padding: 0 !important;
  @media (max-width: 1398px) {
    width: 80% !important;
  }
  @media (min-width: 320px) and (max-width: 1024px) {
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
  }
`;
